import React from 'react';
export function Hero() {
  return <section className="relative min-h-screen bg-white flex items-center pt-16" data-id="element-140">
      <div className="max-w-[1180px] mx-auto px-6 py-6 w-full" data-id="element-141">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-142">
          {/* Content - on mobile: centered, title first, then image, then text */}
          <div className="space-y-5 text-center order-2 lg:order-1" data-id="element-143">
            {/* Decorative line - hidden on mobile */}
            <div className="w-16 h-0.5 bg-magenta mx-auto" data-id="element-144"></div>

            <span className="inline-block text-xs md:text-sm font-medium tracking-widest uppercase text-magenta border border-magenta/30 rounded-full px-5 py-2 bg-blush/50" data-id="element-145">
              COACHING & TERAPIE DE VINDECARE EMOȚIONALĂ
            </span>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium text-magenta leading-tight" data-id="element-146">
              Vindecă trecutul.
              <br data-id="element-147" />
              Trăiește prezentul.
              <br data-id="element-148" />
              Creează viitorul.
            </h1>

            {/* Image on mobile - between title and text */}
            <div className="lg:hidden relative flex flex-col items-center" data-id="element-149">
              <div className="relative w-full max-w-sm" data-id="element-150">
                <div className="absolute -bottom-3 -right-3 w-full h-full rounded-2xl bg-blush border border-cardBorder" data-id="element-151"></div>
                <div className="relative z-10 rounded-2xl overflow-hidden" data-id="element-152">
                  <img src="https://cdn.magicpatterns.com/uploads/dtp3ropdaVQb4tdyMMppCN/Simona_grafic_A_cercuri_concentrice.jpg" alt="Simona Popa" className="w-full h-[400px] object-cover object-top" data-id="element-153" />
                </div>
              </div>
            </div>

            <p className="text-base md:text-lg leading-relaxed text-navy max-w-xl mx-auto" data-id="element-154">
              Un proces profund de transformare 1 la 1 pentru femeile care trec
              prin doliu, divorț, pierdere sau colaps emoțional și simt că este
              momentul să își regăsească echilibrul, puterea și direcția în
              viață.
            </p>

            <div className="space-y-3" data-id="element-155">
              <a href="https://wa.me/40749574631" target="_blank" rel="noopener noreferrer" className="inline-block bg-magenta text-white font-sans text-[15px] font-semibold rounded-full px-9 py-3.5 hover:bg-cyan transition-colors duration-300" data-id="element-156">
                Rezervă Sesiunea CADOU de Evaluare
              </a>
              <p className="text-sm text-muted max-w-md mx-auto" data-id="element-157">
                O sesiune gratuită 1 la 1 în care vedem împreună dacă Terapia
                T.P.V. este potrivită pentru tine.
              </p>
            </div>
          </div>

          {/* Desktop Image with decorative elements */}
          <div className="relative flex-col items-center hidden lg:flex order-1 lg:order-2" data-id="element-158">
            {/* Top decorative accent */}
            <div className="flex items-center gap-3 mb-5" data-id="element-159">
              <div className="w-10 h-px bg-magenta/40" data-id="element-160"></div>
              <div className="w-2 h-2 rotate-45 bg-magenta/25" data-id="element-161"></div>
              <div className="w-24 h-px bg-magenta/30" data-id="element-162"></div>
              <div className="w-2 h-2 rotate-45 bg-cyan/25" data-id="element-163"></div>
              <div className="w-10 h-px bg-magenta/40" data-id="element-164"></div>
            </div>

            <div className="relative w-full" data-id="element-165">
              {/* Offset blush background shape */}
              <div className="absolute -bottom-4 -right-4 w-full h-full rounded-2xl bg-blush border border-cardBorder" data-id="element-166"></div>

              {/* Thin accent line left side */}
              <div className="absolute -left-3 top-12 bottom-12 w-px bg-magenta/20 z-20" data-id="element-167"></div>
              <div className="absolute -left-3 top-12 w-2.5 h-2.5 rounded-full border border-magenta/30 bg-white z-20" data-id="element-168"></div>
              <div className="absolute -left-3 bottom-12 w-2.5 h-2.5 rounded-full border border-cyan/30 bg-white z-20" data-id="element-169"></div>

              {/* Photo */}
              <div className="relative z-10 rounded-2xl overflow-hidden" data-id="element-170">
                <img src="https://cdn.magicpatterns.com/uploads/dtp3ropdaVQb4tdyMMppCN/Simona_grafic_A_cercuri_concentrice.jpg" alt="Simona Popa" className="w-full h-[600px] object-cover object-top" data-id="element-171" />
              </div>
            </div>

            {/* Bottom decorative accent */}
            <div className="flex items-center gap-3 mt-5" data-id="element-172">
              <div className="w-6 h-px bg-cyan/40" data-id="element-173"></div>
              <div className="w-1.5 h-1.5 rounded-full bg-magenta/25" data-id="element-174"></div>
              <div className="w-16 h-px bg-cyan/30" data-id="element-175"></div>
              <div className="w-1.5 h-1.5 rounded-full bg-cyan/25" data-id="element-176"></div>
              <div className="w-6 h-px bg-cyan/40" data-id="element-177"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}